export const get = url => fetchWithTimeout(url, 'GET')
export const getWithRedirect = url => fetchWithRedirect(url)

const ApplicationJsonValue = 'application/json'
const Headers = {
  ACCEPT: 'Accept',
  CONTENT_TYPE: 'Content-Type',
}

const fetchWithTimeout = (url, method, timeout = 30000) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject('Timeout'), timeout)

    fetch(url, {
      method,
      headers: {
        [Headers.ACCEPT]: ApplicationJsonValue,
        [Headers.CONTENT_TYPE]: ApplicationJsonValue,
      },
      mode: 'cors',
      redirect: 'follow',
      cache: 'default',
      credentials: 'same-origin',
    })
      .then(response => {
        clearTimeout(timer)
        if (response.status >= 200 && response.status < 300) {
          return resolve(isJson(response) ? response.json() : {})
        }
        if (isJson(response)) {
          return reject(handleError(response.json()))
        }
        return reject(handleError())
      })
      .catch(reject)
  })
}

const fetchWithRedirect = (url, timeout = 30000) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject('Timeout'), timeout)

    fetch(url, {
      method: 'GET',
      redirect: 'manual',
    })
      .then(response => {
        clearTimeout(timer)
        if (response.type === 'opaqueredirect' || response.status === 0) {
          window.location.href = url
          return resolve()
        }
        if (response.status >= 300 && response.status < 400) {
          const location = response.headers.get('Location')
          if (location) {
            window.location.href = location
            return resolve()
          }
        }
        if (response.status >= 200 && response.status < 300) {
          return resolve(isJson(response) ? response.json() : {})
        }
        if (isJson(response)) {
          return reject(handleError(response.json()))
        }
        return reject(handleError())
      })
      .catch(reject)
  })
}

const isJson = response =>
  response.headers.get(Headers.CONTENT_TYPE) === ApplicationJsonValue

const handleError = ({ message } = {}) => message || 'Generic Error'
